import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TModalOpt = {
  title?: string;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  canClose?: boolean;
  type: 'default' | 'bottom';
};

const defaultOpt: TModalOpt = {
  title: '',
  size: 'md',
  canClose: true,
  type: 'default',
};

type TInitialState = {
  open: boolean;
} & TModalPayload;

type TModalPayload = {
  children: JSX.Element | null;
  opt: TModalOpt;
};

const INITIAL_STATE: TInitialState = {
  open: false,
  children: null as unknown as JSX.Element,
  opt: defaultOpt,
};

export type ModalState = Readonly<typeof INITIAL_STATE>;

const modalSlice = createSlice({
  name: 'post',
  initialState: INITIAL_STATE,
  reducers: {
    openModal(state, action: PayloadAction<TModalPayload>): TInitialState {
      return {
        open: true,
        children: action.payload.children,
        opt: {
          ...state.opt,
          ...action.payload.opt,
        },
      };
    },
    closeModal() {
      return INITIAL_STATE;
    },
    updateModalOptions(state, action: PayloadAction<TModalOpt>): TInitialState {
      return {
        ...state,
        opt: action.payload,
      };
    },
    setModalCanClose(state, action: PayloadAction<boolean>): TInitialState {
      return {
        ...state,
        opt: {
          ...state.opt,
          canClose: action.payload,
        },
      };
    },
  },
});

const { actions, reducer } = modalSlice;
export const { openModal, closeModal, updateModalOptions, setModalCanClose } = actions;
export default reducer;
